"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popover = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _statusIconAppearance = require("../../util/statusIconAppearance");
var _PopoverArrow = require("../PopoverArrow/PopoverArrow");
var _PopoverIcon = require("../PopoverIcon/PopoverIcon");
var _Popover = require("./Popover.styles");
var _excluded = ["arrowRef", "children", "icon", "shouldTakeFocus"];
var PopoverComponent = function PopoverComponent(props) {
  var arrowRef = props.arrowRef,
    children = props.children,
    icon = props.icon,
    shouldTakeFocus = props.shouldTakeFocus,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var content = children;
  if (typeof children === 'function') {
    content = children(props);
  }
  var iconContent = icon;
  if (typeof iconContent === 'function') {
    iconContent = iconContent(props);
  }
  if (iconContent) {
    iconContent = /*#__PURE__*/_react.default.createElement(_PopoverIcon.PopoverIcon, null, iconContent);
  }
  return /*#__PURE__*/_react.default.createElement(_Popover.StyledPopover, (0, _extends2.default)({
    shouldTakeFocus: false,
    icon: iconContent
  }, rest), content, iconContent, /*#__PURE__*/_react.default.createElement(_PopoverArrow.PopoverArrow, {
    ref: arrowRef
  }));
};

/**
 * You will almost always want to use this in conjunction with the `Popper` component.
 *
 * @related ['Dialog', 'Heading', 'Popper', 'TriggerButton', 'TriggerText']
 * @extends Modal
 * @since 7.0.0
 */
var Popover = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(PopoverComponent, (0, _extends2.default)({
    innerRef: forwardedRef || undefined
  }, props));
});
exports.Popover = Popover;
Popover.displayName = 'Popover';
Popover.propTypes = {
  /**
   * Change the appearance of the popover. By default there is no appearance.
   */
  appearance: _propTypes.default.oneOf(Object.values(_constants.STATUS_TYPES)),
  /**
   * A [React Ref](https://reactjs.org/docs/refs-and-the-dom.html) that will be given to the
   * `PopoverArrow` node. This is usually provided by the `Popper` component.
   */
  arrowRef: _customPropTypes.default.ref,
  /**
   * The Dialog `children` content amended with a `PopoverArrow` and global style.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * The `Modal` `globalStyle` node.
   */
  globalStyle: _propTypes.default.node,
  /**
   * A `Heading` is **required** to give context
   * about the popover content. This is especially helpful for `modal` popovers where there
   * is no arrow to give context.
   */
  header: _propTypes.default.node,
  /**
   * The icon node. By default, this will use an icon based on the popover `appearance`, using no
   * icon if there is not an appearance.
   */
  icon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * The Dialog `shouldTakeFocus` prop is always set
   * to false as focus for popovers is handled by the
   * `Popper` component.
   */
  shouldTakeFocus: _propTypes.default.bool,
  /**
   * When true, the popover will behave like a modal.
   *
   * Supports inline media query objects.
   */
  modal: _customPropTypes.default.inlineMediaQuery(_propTypes.default.bool),
  /**
   * @deprecated Use inline media query objects
   */
  mediaQuery: _customPropTypes.default.mediaQuery
};
Popover.defaultProps = {
  icon: _statusIconAppearance.statusIconAppearance,
  shouldTakeFocus: false,
  globalStyle: /*#__PURE__*/_react.default.createElement(_Popover.PopoverGlobalStyle, null),
  modal: {
    sm_lte: true
  }
};